import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { singleton } from "logic/singleton";
const InvestigationDrawerContext = createContext(null);
export function InvestigationDrawerProvider({ children }) {
  const getCurrentInvestigationId = useCallback(() => {
    var _a;
    try {
      return (_a = localStorage.getItem("currentInvestigationId")) != null ? _a : void 0;
    } catch {
      return void 0;
    }
  }, []);
  const initialId = getCurrentInvestigationId();
  const [showDrawer, setShowDrawer] = useState(!!initialId);
  const [collapsed, setCollapsed] = useState(!!initialId);
  const [fullScreen, setFullScreen] = useState(false);
  const [selectedInvestigationId, setSelectedInvestigationId] = useState(initialId);
  const updateInvestigationId = useCallback((investigationId) => {
    if (!investigationId) return;
    setSelectedInvestigationId(investigationId);
    try {
      localStorage.setItem("currentInvestigationId", investigationId);
    } catch {
    }
  }, []);
  const clearInvestigation = useCallback(() => {
    setSelectedInvestigationId(void 0);
    setShowDrawer(false);
    setCollapsed(true);
    setFullScreen(false);
    try {
      localStorage.removeItem("currentInvestigationId");
    } catch {
    }
  }, []);
  const contextValue = useMemo(
    () => ({
      collapsed,
      setCollapsed,
      showDrawer,
      setShowDrawer,
      fullScreen,
      setFullScreen,
      clearInvestigation,
      selectedInvestigationId,
      setSelectedInvestigationId: updateInvestigationId
    }),
    [
      collapsed,
      setCollapsed,
      showDrawer,
      setShowDrawer,
      fullScreen,
      setFullScreen,
      clearInvestigation,
      selectedInvestigationId,
      updateInvestigationId
    ]
  );
  return /* @__PURE__ */ React.createElement(InvestigationDrawerContext.Provider, { value: contextValue }, children);
}
export const useInvestigationDrawer = singleton(
  "security.useInvestigationDrawer",
  () => () => useContext(InvestigationDrawerContext)
);
